import { render, staticRenderFns } from "./wholesaleGoods.vue?vue&type=template&id=4e032410&scoped=true"
import script from "./wholesaleGoods.vue?vue&type=script&lang=js"
export * from "./wholesaleGoods.vue?vue&type=script&lang=js"
import style0 from "./wholesaleGoods.vue?vue&type=style&index=0&id=4e032410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e032410",
  null
  
)

export default component.exports